import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Card } from "react-bootstrap";
import "../../../index.css";
import { ContentContainer } from "../SessionSection";
import DriveThruAffiliateHeader from "../driveThruAffiliateHeader/driveThruAffiliateHeader.component";
import ModalComponent from "../modal/modal.component";
import ImageComponent from "../image/image.component";
import { useEffect } from "react";
import "./blade-runner-styles.scss";
import bladeRunnerLogo from "../../../../src/assets/blade-runner/logo-blade-runner.webp";
import cover from "../../../../src/assets/blade-runner/session10/blade-runner-session-10-cover.webp";
import vk from "../../../../src/assets/blade-runner/session10/skinner-voight-kampff.webp";
import husky from "../../../../src/assets/blade-runner/session10/marion-and-husky.webp";
// NOTE: No Session 10 images were provided with the writeup.
// If you add them later, import them here and add <ImageComponent /> blocks inside sections.

const pageHeader = {
  color: "white",
  backgroundColor: "black",
  opacity: "0.7",
  marginTop: "20px",
  padding: "15px",
};

const cardStyle = {
  textAlign: "left",
  fontFamily: "Special Elite",
  backgroundColor: "rgba(0, 0, 0, 0.7) ",
  color: "white",
  marginBottom: "15px",
};

const BRSession10 = () => {
  const [showModal, setShowModal] = React.useState("");
  const [modalData, setModalData] = React.useState({});

  const handleClick = (img, body, isLegend, caption) => {
    setModalData({
      body: body,
      image: img,
      isLegend: isLegend,
      caption: caption,
    });
    handleOpenModal();
  };
  const handleOpenModal = () => setShowModal("show");
  const handleCloseModal = () => setShowModal("", "");

  const section1Data = [
    {
      title: "Downtime: Wanda Glitches & Grimsky's Warning (Day 2, Shift 4)",
      text: (
        <div className="bladeRunnerFont bladeRunnerTitleText">
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>

          <ImageComponent
            image={cover}
            caption="Neon Mirror"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Blade Runner Session 10: Marion and Skinner search McCoy's apartment."
          ></ImageComponent>
          <p>
            Marion’s DiJi, <strong>Wanda</strong>, acts up tonight. She’s an
            older model—the only one he could afford. The scan refresh rate is
            still good, but the{" "}
            <strong>projection resolution keeps fritzing</strong>, and her{" "}
            <strong>AI language/feedback lags</strong> like she’s thinking
            through wet static.
          </p>

          <p>
            The stress wears him down: <strong>Marion takes -1 Resolve</strong>.
            He knows he has to get <strong>tech support</strong> to fix her.
          </p>

          <p>
            He grips his <strong>MVP football ring</strong>—a grounding habit, a
            memory he can trust. He uses it to self-comfort and{" "}
            <strong>repair the Resolve damage</strong>.
          </p>
          <p>
            Skinner spends his downtime at <strong>the Overlook</strong> with
            his foster brother <strong>Lloyd</strong>. Then Grimsky calls—says
            he has information, but he wants a{" "}
            <strong>get-out-of-jail-free card</strong> in return.
          </p>

          <p>
            Skinner agrees:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              “Next time you get in trouble, I’ll pull some strings.”
            </font>
          </p>

          <p>
            Grimsky delivers: one of his rueboys spotted <strong>McCoy</strong>{" "}
            down by the <strong>Sepulveda Sea Wall</strong> with a case that
            looked like a <strong>high-end sniper rifle setup</strong>, like he
            was about to set up shop on a rooftop. Grimsky warns:
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              {" "}
              “One of me rueboys was spying McCoy with a case down by Sepulveda
              Sea Wall. That case was a high-end sniper rifle—looks like he was
              going to set up shop on some rooftop. Be careful if you go there.”
            </font>
          </p>

          <p>
            Skinner’s gut tightens. McCoy is breaking bad. And Tyrell might be
            “defunct,” but not dead. Skinner tells Grimsky:
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              {" "}
              “This McCoy guy is breaking bad. We think of Tyrell as defunct,
              but they may not be as dead as we think.”
            </font>
          </p>

          <p>
            He adds what they’ve seen—<strong>Lilith Tyrell</strong> and{" "}
            <strong>black-market replicants</strong> on the street. It all feels{" "}
            <strong>Tyrell-adjacent</strong>.
          </p>

          <p>
            Skinner calls Marion:
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              {" "}
              “As much as I’d like to check out Runciter’s Zoological, I want to
              go to Sea Wall.”
            </font>
            <br />
            Then, with that dry edge:
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              {" "}
              “However, if you want to make the city laugh… make a plan.”
            </font>
          </p>

          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },

    {
      title: "The VK Trap: McCoy Tests Skinner (Day 3, Shift 1)",
      text: (
        <div className="bladeRunnerFont bladeRunnerTitleText">
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>

          <ImageComponent
            image={vk}
            caption="Voight-Kampff"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Skinner in the hot seat being tested to see if he is a replicant."
          ></ImageComponent>
          <p>
            Holden calls and orders Skinner down to LAPD. Marion gets suspicious
            and follows inconspicuously. Skinner keeps his KIA open to Marion as
            Sgt. Reardon points him toward the interrogation level—two doors
            down from where Skinner tested Ellis Vale.
          </p>

          <p>
            Inside: Holden, McCoy, and two beat cops. Holden says:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              “Work with McCoy, Skinner. We’ll get this cleared up.”
            </font>
          </p>

          <p>
            Holden leaves. McCoy settles back while the beat cops stand behind
            Skinner. McCoy starts hooking Skinner up to the Voight-Kampff
            machine, smiling like a knife.{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              “Just like back in the academy days, eh?”
            </font>{" "}
            That’s when it hits Skinner: McCoy isn’t testing a suspect—he’s
            testing <em>him</em>.
          </p>

          <p>
            McCoy starts digging straight into Skinner’s key memory.{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              “First question: You’re at a party; and you’re a kid. You see your
              parents using drugs at the party. How do you feel?”
            </font>
          </p>

          <p>
            Skinner answers carefully:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              “I feel something like that might haunt me my whole life.”
            </font>
            <br />
            McCoy prods, smirking:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              “What will haunt you? The trauma with your parents?”
            </font>
            <br />
            Skinner snaps back:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              “Yeah, that’s it. Maybe you’ll want to take a turn in this chair
              when I’m done.”
            </font>
          </p>

          <p>
            Meanwhile, Marion parks on the maintenance/visitor lot on the
            interrogation level—RDU badge doing the talking. He gets accosted by
            an old man fresh out of interrogation, pestering him for money and a
            ride back to Sector 3. Marion makes a FORCE roll and shoves him
            aside like debris, pushing toward the doors.
          </p>

          <p>
            Back in the room, McCoy fires off another question:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              “You’re in a dark room. You can’t see anything, but you hear a
              baby crying; it goes on and on. How do you respond?”
            </font>
            <br />
            Skinner:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              “Is that baby you?”
            </font>
            <br />
            McCoy:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              “C’mon, Skinner. I’m old enough to be your brother.”
            </font>
          </p>

          <p>
            Marion reaches the door into the interrogation area—beat cop blocks
            him:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              “No go, Detective Carey. Sorry—Holden’s orders.”
            </font>{" "}
            Marion plays it cool and waits, acting like he’s just here for his
            partner.
          </p>

          <p>
            McCoy slides over a stelline print of the Skinner-lookalike
            replicant running through rain on the roof of Bright Eyes Salon:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              “What do you think of this photo?”
            </font>
            <br />
            Skinner:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              “I see a man with a lot of grit. A man you can learn a lesson
              from.”
            </font>
            <br />
            McCoy:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              “That’s funny. I see a man who lies… I see dirt that needs to be
              swept up. I see a rogue replicant.”
            </font>
            <br />
            Skinner:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              “Might take one to know one.”
            </font>
          </p>

          <p>
            McCoy presses on:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              “You’re watching television. There’s a wasp on your arm—what do
              you do?”
            </font>
            <br />
            Skinner:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              “I look into its multi-faceted eyes and dream of your mother… and
              that special moment I had with her.”
            </font>
          </p>

          <p>
            McCoy almost blows his lid, then resets and tries again:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              “You’re in a room. Everyone is laughing at a joke. But you don’t
              understand the joke. How does it feel to be the only one who
              doesn’t understand?”
            </font>
            <br />
            Skinner:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              “When I met you, I didn’t realize you were a joke.”
            </font>
          </p>

          <p>
            McCoy, tight-lipped:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              “Describe in single words only the good things about your mother.”
            </font>
            <br />
            Skinner (each word a blade):{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              “My mother was real. Yours is a ghost.”
            </font>
          </p>

          <p>
            McCoy suddenly announces the test is over. Skinner says:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              “You’re not the real McCoy, and you know that.”
            </font>
            <br />
            McCoy declares the test “shows” Skinner is a replicant, and moves to
            arrest him:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              “I’m sorry… Are you sure those memories you have of life as a
              human are your own, and not implants? …You are under arrest. Let’s
              not make this any harder than necessary.”
            </font>
          </p>

          <p>
            Skinner protests—louder and louder—while the beat cops close in.
            Outside, the cop with Marion gets a radio call:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              “He’s resisting—get in here, we need backup.”
            </font>{" "}
            The cop turns to open the door… and Marion hits him like weather: a
            non-lethal blood choke, then a quiet collapse.
          </p>

          <p>
            Marion bursts in. Like twins, he and Skinner understand the plan:{" "}
            <strong>run</strong>. Foot chase. Skinner’s bad knee/back slows him,
            Marion drops back to keep pace—but the cops are gaining.
          </p>

          <p>
            Skinner grins:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              “They took my KIA and my PKD blaster… but they didn’t get this.”
            </font>{" "}
            He produces a tear gas grenade the cops missed (no full pat-down out
            of “respect”), drops the canister, and the hallway becomes choking
            chaos. The beat cops fall behind as Skinner and Marion break free.
          </p>

          <p>
            They assume the spinner can be tracked. Not trusting their TECH to
            mask GPS, Skinner calls street asset Corgi using Marion’s KIA. They
            dump the spinner in an abandoned Koreatown lot and trade down to a
            cramped rooftop hopper.
            <br />
            Corgi shrugs:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              “Best I could do on short notice, gents.”
            </font>{" "}
            The craft looks like a dented metal egg with duct-taped hazard
            stripes.
            <br />
            Corgi sells it anyway:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              “Look—it’s inconspicuous. And it can land in much smaller spaces
              than a spinner.”
            </font>
          </p>

          <p>
            As they squeeze into the hopper cockpit, Marion gets a call from
            Wanda. Her projection flickers, voice looping “hello,” eyes not
            tracking the camera. Then her voice morphs into a low masculine
            rasp:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              “Don’t trust him. Don’t trust McCoy.”
            </font>{" "}
            The line goes dead. The trace points to McCoy’s apartment.
            <br />
            Skinner says:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              “That’s the real McCoy… He probably hacked a message into the
              network, hoping it would get found on LAPD channels or devices. We
              have to go to his apartment.”
            </font>
          </p>

          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },

    {
      title: "McCoy's Apartment (Day 3, Shift 2)",
      text: (
        <div className="bladeRunnerFont bladeRunnerTitleText">
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>

          <ImageComponent
            image={husky}
            caption="Animoid Husky"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Marion faces off with violent animoid husky."
          ></ImageComponent>
          <p>
            McCoy lives in a worn-out high rise. His apartment is larger than
            standard LAPD issue these days—seniority space. It even has a
            balcony. The fallen opulence is still a badge in the Rep Detect
            Unit.
          </p>

          <p>
            Marion and Skinner land the hopper on the roof. The TECH security on
            the maintenance door is far less complicated than the lobby and
            elevator access, so they go in quiet and high, then slip down into
            McCoy’s floor and into his apartment.
          </p>

          <p>
            Marion draws his PKD as Skinner falls in behind him; Skinner might
            not have a weapon, but he’s still a set of trained eyes. In the
            bedroom, they find a body sprawled on top of the covers—bloody,
            wrong, still. Skinner moves in to check if it’s a corpse or a living
            victim while Marion clears the living area near the balcony.
          </p>

          <p>
            A sudden explosive bark erupts from the bathroom and an animoid
            husky launches at Marion. Marion’s MVP reflexes save him—he twists
            just enough to avoid the bite and fires. The dog drops… but then
            something stranger kicks in: a dormant self-preservation protocol.
            Wounded, it shifts into a neutral rest position, looks up at him
            like it’s waiting for permission to shut down.
          </p>

          <p>
            Marion doesn’t hesitate. He puts the gun to its head and finishes
            the job without remorse.
          </p>

          <p>
            Skinner sees it clearly now: they found the <em>real</em> McCoy.
            He’s beaten nearly to death—needs extraction and a hospital—yet
            Skinner feeds him an Instant Fix pill. It doesn’t make him whole,
            but it buys a moment. McCoy mutters:
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              {" "}
              “Wallace… they’re after… Wallace.”
            </font>{" "}
            Then he slips under again.
          </p>

          <p>
            Marion and Skinner collect what they can fast: blood sample,
            fingerprints, photos—McCoy, the room, the violence, every detail
            that can’t be argued away later.
          </p>

          <p>
            Skinner calls Grimsky and arranges a safehouse to stash the
            senseless but stabilized McCoy. Skinner says:
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              {" "}
              “Make sure it’s got privacy.”
            </font>
            <br />
            Grimsky replies:
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              {" "}
              “Ya, grandpa, sure thing.”
            </font>
            <br />
            Skinner ends the call with:
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              {" "}
              “And Grimsky—make sure you leave a firearm there. Anything will
              do, just as long as it can shoot.”
            </font>
          </p>

          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },
  ];

  useEffect(() => {
    document.body.style.backgroundImage = `url(${require("../../../../src/assets/blade-runner/background-blade-runner-01.webp")})`;
    document.body.style.backgroundColor = "#000000";
    document.body.style.backgroundWidth = "100vw";
    document.body.backgroundHeight = "100vh";
    document.body.style.backgroundSize = "cover";
  }, []);

  return (
    <Container>
      <Row>
        <Col>
          <div
            style={{
              backgroundColor: "transparent",
              fontFamily: "Orbitron",
            }}
          >
            <div style={pageHeader}>
              <main role="main" className="inner cover text-center">
                <DriveThruAffiliateHeader
                  gameName="Blade Runner"
                  logo={bladeRunnerLogo}
                  productUrl="https://www.drivethrurpg.com/en/product/399929/Blade-Runner-RPG-Core-Rulebook?affiliate_id=844642"
                  logoMaxWidth="200px"
                  logoStyle={{ backgroundColor: "white", borderRadius: "10px" }}
                />
              </main>

              <h1 className="cover-heading">MCCOY</h1>
              <small>Blade Runner Session 10</small>
            </div>
          </div>
        </Col>
      </Row>

      <Row>
        <Col>
          <Card style={cardStyle}>
            <Card.Body>
              <Card.Title
                id="cardTitle-blade-runner"
                className="cardTitle-blade-runner"
              >
                <span
                  style={{
                    color: "white",
                    textAlign: "center",
                  }}
                >
                  Skinner and Marion are on the run, betrayed, racing to fid the
                  real McCoy.
                </span>
                <br />
                <font
                  style={{
                    color: "#C21E56",
                    textAlign: "center",
                    fontStyle: "italic",
                  }}
                >
                  WARNING: SPOILERS for Fiery Angels case file.{" "}
                </font>
                <br />
                <small>
                  ⇐ Session 09:{" "}
                  <a href="./blade-runner-session-09">Neon Mirror</a> ☠ Session
                  11: <a href="./blade-runner-session-11">Mother</a> ⇒{" "}
                </small>
              </Card.Title>

              <div>
                <ContentContainer data={section1Data} />
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default BRSession10;
